import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-alert-background-color: var(--sds-alert-background-color, var(--sds-color-alert-info-surface-tinted));

		--_sds-alert-border-color: var(--sds-alert-border-color, var(--sds-color-alert-info-border-default));
		--_sds-alert-border-radius: var(--sds-alert-border-radius, var(--sds-radius-sm));
		--_sds-alert-border-width: var(--sds-alert-border-width, var(--sds-border-sm));

		--_sds-alert-column-gap: var(--sds-alert-column-gap, var(--sds-spacing-2xs));
		--_sds-alert-content-gap: var(--sds-alert-content-gap, var(--sds-spacing-3xs));

		--_sds-alert-font-family: var(--sds-alert-font-family, var(--sds-typography-font-family-roboto));
		--_sds-alert-text-color: var(--sds-alert-text-color, var(--sds-color-alert-info-text-default));

		--_sds-alert-font-size: var(--sds-alert-font-size, var(--sds-components-font-size-content-md));
		--_sds-alert-font-weight: var(--sds-alert-font-weight, var(--sds-typography-body-md-desktop-font-weight));
		--_sds-alert-line-height: var(--sds-alert-line-height, var(--sds-components-line-height-tall-content-md));

		--_sds-alert-title-font-size: var(--sds-alert-title-font-size, var(--sds-components-font-size-title-md));
		--_sds-alert-title-font-weight: var(--sds-alert-title-font-weight, var(--sds-typography-body-lg-strong-tall-desktop-font-weight));
		--_sds-alert-title-line-height: var(--sds-alert-title-line-height, var(--sds-components-line-height-tall-title-md));

		--_sds-alert-icon-color: var(--sds-alert-icon-color, var(--sds-color-alert-info-text-subtle));
		--_sds-alert-icon-color-background: var(--sds-alert-icon-color-background, var(--sds-color-action-contrast-default, white));
		--_sds-alert-max-line-width: var(--sds-alert-max-line-width, var(--sds-typography-max-line-width));
		--_sds-alert-padding: var(--sds-alert-padding, var(--sds-spacing-sm));

		--sds-icon-color: var(--sds-alert-icon-color, var(--_sds-alert-icon-color));

		display: block;
	}

	.sds-alert {
		display: flex;
		gap: var(--_sds-alert-column-gap);
		padding: var(--_sds-alert-padding);
		background-color: var(--_sds-alert-background-color);
		border: var(--_sds-alert-border-width) solid var(--_sds-alert-border-color);
		border-radius: var(--_sds-alert-border-radius);
		color: var(--_sds-alert-text-color);
		font-family: var(--_sds-alert-font-family);
		text-align: left;
	}

	:host([data-palette='success']) {
		--_sds-alert-icon-color: var(--sds-alert-icon-color, var(--sds-color-alert-success-text-subtle));
		--_sds-alert-border-color: var(--sds-alert-border-color, var(--sds-color-alert-success-border-default));
		--_sds-alert-background-color: var(--sds-alert-background-color, var(--sds-color-alert-success-surface-tinted));
		--_sds-alert-text-color: var(--sds-alert-text-color, var(--sds-color-alert-success-text-default));
	}

	:host([data-palette='danger']) {
		--_sds-alert-icon-color: var(--sds-alert-icon-color, var(--sds-color-alert-danger-text-subtle));
		--_sds-alert-border-color: var(--sds-alert-border-color, var(--sds-color-alert-danger-border-default));
		--_sds-alert-background-color: var(--sds-alert-background-color, var(--sds-color-alert-danger-surface-tinted));
		--_sds-alert-text-color: var(--sds-alert-text-color, var(--sds-color-alert-danger-text-default));
	}

	:host([data-palette='attention']) {
		--_sds-alert-icon-color: var(--sds-alert-icon-color, var(--sds-color-alert-attention-text-subtle));
		--_sds-alert-border-color: var(--sds-alert-border-color, var(--sds-color-alert-attention-border-default));
		--_sds-alert-background-color: var(--sds-alert-background-color, var(--sds-color-alert-attention-surface-tinted));
		--_sds-alert-text-color: var(--sds-alert-text-color, var(--sds-color-alert-attention-text-default));
	}

	:host([data-palette='warning']) {
		--_sds-alert-icon-color: var(--sds-alert-icon-color, var(--sds-color-alert-warning-text-subtle));
		--_sds-alert-border-color: var(--sds-alert-border-color, var(--sds-color-alert-warning-border-default));
		--_sds-alert-background-color: var(--sds-alert-background-color, var(--sds-color-alert-warning-surface-tinted));
		--_sds-alert-text-color: var(--sds-alert-text-color, var(--sds-color-alert-warning-text-default));
	}

	.sds-alert__type {
		color: var(--_sds-alert-icon-color);
		display: flex;
		align-items: start;
		flex-wrap: wrap;
	}

	.sds-alert__content {
		align-self: center;
		display: flex;
		flex: 1;
		flex-direction: column;
	}

	.sds-alert__actions {
		--sds-button-padding-inline: 0;
		--sds-button-text-color: var(--_sds-alert-text-color);
	}

	.sds-alert__icon {
		display: block;
		position: relative;
		z-index: 1;
	}

	:host([variant='secondary']) {
		--_sds-alert-background-color: var(--sds-alert-background-color, transparent);
		--_sds-alert-border-color: var(--sds-alert-border-color, transparent);
		--_sds-alert-border-width: var(--sds-alert-border-width, 0);
		--_sds-alert-padding: var(--sds-alert-padding, 0);
		--_sds-alert-column-gap: var(--sds-alert-column-gap, var(--sds-spacing-3xs));
		--_sds-alert-content-gap: var(--sds-alert-content-gap, var(--sds-spacing-4xs));

		--_sds-alert-line-height: var(--sds-alert-line-height, var(--sds-components-line-height-tall-content-md));
		--_sds-alert-font-weight: var(--sds-alert-font-weight, var(--sds-typography-body-md-tall-desktop-font-weight));

		position: relative;

		&::after {
			content: '';
			position: absolute;
			top: 4px;
			left: 4px;
			width: 16px;
			height: 16px;
			background-color: var(--_sds-alert-icon-color-background);
			z-index: -1;
			clip-path: circle(50%);
		}

		&:host([size='sm'])::after {
			width: 10px;
			height: 10px;
		}
	}

	:host([variant='secondary']):host([data-palette='attention']) {
		--sds-icon-color: var(--sds-alert-icon-color, var(--sds-color-action-default));

		&::after {
			top: 4px;
			left: 2px;
			width: 20px;
			height: 16px;
			clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
		}
	}

	:host([variant='secondary']):host([size='sm']) {
		--_sds-alert-font-size: var(--sds-alert-font-size, var(--sds-components-font-size-content-sm));
		--_sds-alert-line-height: var(--sds-alert-line-height, var(--sds-components-line-height-tall-content-sm));
		--_sds-alert-title-font-size: var(--sds-alert-title-font-size, var(--sds-components-font-size-title-sm));
		--_sds-alert-title-line-height: var(--sds-alert-title-line-height, var(--sds-components-line-height-tall-title-sm));
	}

	:host([variant='secondary']):host([size='md']) {
		--_sds-alert-font-size: var(--sds-alert-font-size, var(--sds-components-font-size-content-md));
		--_sds-alert-line-height: var(--sds-alert-line-height, var(--sds-components-line-height-tall-content-md));
		--_sds-alert-title-font-size: var(--sds-alert-title-font-size, var(--sds-components-font-size-title-md));
		--_sds-alert-title-line-height: var(--sds-alert-title-line-height, var(--sds-components-line-height-tall-title-md));
	}

	:host([variant='secondary']):host([size='lg']) {
		--_sds-alert-font-size: var(--sds-alert-font-size, var(--sds-components-font-size-content-lg));
		--_sds-alert-line-height: var(--sds-alert-line-height, var(--sds-components-line-height-tall-content-lg));
		--_sds-alert-title-font-size: var(--sds-alert-title-font-size, var(--sds-components-font-size-title-lg));
		--_sds-alert-title-line-height: var(--sds-alert-title-line-height, var(--sds-components-line-height-tall-title-lg));
	}

	::slotted([slot='title']),
	::slotted(:is(h1, h2, h3, h4, h5, h6)) {
		color: var(--_sds-alert-text-color) !important;
		font-size: var(--_sds-alert-title-font-size) !important;
		font-style: normal !important;
		font-weight: var(--_sds-alert-title-font-weight) !important;
		line-height: var(--_sds-alert-title-line-height) !important;
		margin: 0 !important;
		max-width: var(--_sds-alert-max-line-width) !important;
	}

	::slotted([slot='message']),
	::slotted(:is(p)) {
		color: var(--_sds-alert-text-color) !important;
		font-size: var(--_sds-alert-font-size) !important;
		font-style: normal !important;
		font-weight: var(--_sds-alert-font-weight) !important;
		line-height: var(--_sds-alert-line-height) !important;
		margin: 0 !important;
		max-width: var(--_sds-alert-max-line-width) !important;
	}
`;
